import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const assetsApi = {
  transferMargin(query) {
    return http.put(API_URLS.MARGIN, {query});
  },
  indexQuote(query) {
    return http.get(API_URLS.INDEX_QUOTE, {query});
  },
  transfer(params) {
    return http.post(API_URLS.TRANSFER, {params});
  },
  getFiatBizGary() {
    return http.get(API_URLS.FIAT_BIZ_GARY, {});
  },
  getDataAssetsOverview(query) {
    return http.get(API_URLS.DATA_ASSETS_OVERVIEW, {query});
  },
};
